import { HHStack } from '@hinge-health/react-component-library';
import { GridPaginationModel } from '@mui/x-data-grid-pro';
import { useState } from 'react';
import { PartnershipType } from '../../../../../types';
import {
  BillingType,
  ClientType,
  useGetAllInternalHoldTypesQuery,
} from '../../../types';
import {
  BillManagementGridFilterModelType,
  InsurersType,
} from '../bill-grid-components/bill-management-types';
import { AdvancedFilters } from './advanced-filters/advanced-filters';
import { QuickFilters } from './quick-filters';

export interface BillManagementFiltersProps {
  filterParams: BillManagementGridFilterModelType;
  setFilterParams: React.Dispatch<
    React.SetStateAction<BillManagementGridFilterModelType>
  >;
}

export interface BillManagementFiltersPropsWithClientsAndInsurersAndPartnerships
  extends BillManagementFiltersProps {
  clients: ClientType[];
  insurers: InsurersType[];
  partnerships: PartnershipType[];
  billingTypes: BillingType[];
  setPaginationModel: React.Dispatch<React.SetStateAction<GridPaginationModel>>;
  isLoading: boolean;
  hasError: boolean;
  onResetSearch: () => void;
}

export interface BillManagementFiltersToolbarProps
  extends BillManagementFiltersPropsWithClientsAndInsurersAndPartnerships {
  defaultFiltersOpen: boolean;
}

const BillManagementFilters = ({
  clients,
  insurers,
  partnerships,
  billingTypes,
  filterParams,
  setFilterParams,
  setPaginationModel,
  isLoading,
  hasError,
  onResetSearch,
  defaultFiltersOpen,
}: BillManagementFiltersToolbarProps): JSX.Element => {
  const [advancedFiltersOpen, setAdvancedFiltersOpen] =
    useState(defaultFiltersOpen);

  const {
    data: allHoldTypes,
    error: allHoldTypesError,
    loading: holdsLoading,
  } = useGetAllInternalHoldTypesQuery();

  const holdTypes =
    allHoldTypes?.getAllInternalHoldTypes.map(type => type.value) ??
    filterParams.holdReasons;

  const dataLoading = isLoading || holdsLoading;

  return (
    <HHStack paddingLeft={6}>
      {advancedFiltersOpen && !dataLoading ? (
        <AdvancedFilters
          filterParams={filterParams}
          setFilterParams={setFilterParams}
          clients={clients}
          insurers={insurers}
          partnerships={partnerships}
          hasError={hasError}
          holdTypes={holdTypes}
          holdTypesError={allHoldTypesError}
          billingTypes={billingTypes}
          filterToggle={(): void =>
            setAdvancedFiltersOpen(!advancedFiltersOpen)
          }
          setPaginationModel={setPaginationModel}
          isLoading={isLoading}
          onResetSearch={onResetSearch}
        />
      ) : (
        <QuickFilters
          filterParams={filterParams}
          setFilterParams={setFilterParams}
          filterToggle={(): void =>
            setAdvancedFiltersOpen(!advancedFiltersOpen)
          }
          setPaginationModel={setPaginationModel}
        />
      )}
    </HHStack>
  );
};

export default BillManagementFilters;
